module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    staticClass: "row all",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('Menu', {
    ref: "menu"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "col all-col",
    attrs: {
      "id": "app-content"
    }
  }, [_c('Header'), _vm._v(" "), _c('Modal'), _vm._v(" "), _c('v-btn', {
    staticClass: "botton-top-app",
    staticStyle: {
      "outline": "none"
    },
    attrs: {
      "fab": "",
      "dark": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "#981010"
    },
    on: {
      "click": function($event) {
        _vm.$refs.content.scrollTop = 0, _vm.$refs.content_mobile.scrollTop = 0, _vm.$root.$emit('all.scroll')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), [(_vm.isButton) ? _c('div', {
    staticClass: "row is-mobile full-with-r-button",
    staticStyle: {
      "height": "34px"
    }
  }, [_c('div', {
    staticClass: "col col-in-r-button"
  }, [_c('span', {
    staticClass: "text-r-button",
    on: {
      "click": function($event) {
        _vm.$root.$emit('modal.applying'), _vm.isButton = false;
      }
    }
  }, [_vm._v("\n              Срочная помощь адвоката\n            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isButton = !_vm.isButton
      }
    }
  }, [_vm._v("\n              X\n            ")])])]) : _vm._e()], _vm._v(" "), _c('div', {
    ref: "content_mobile",
    staticClass: "content-main",
    attrs: {
      "id": "app-content_mobile"
    }
  }, [_c('router-view', {
    key: _vm.$route.params.id,
    attrs: {
      "id": "all_content"
    }
  })], 1), _vm._v(" "), (_vm.$route.meta.name != 'info') ? _c('Footer') : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42d9e6c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/App.vue
// module id = 352
// module chunks = 2